<template>
  <v-container fluid grid-list-xl>
    <v-layout row fill-height>
      <v-flex xs12>
        <v-btn small to="/quotes">Back to Quotes</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row fill-height wrap>
      <v-flex xs12 sm6>
        <v-form enctype='multipart/form-data'>
          <div v-if="this.$route.params.id">
            <label>Order Code: <b>{{ order.orderCode }}</b></label>
          </div>
          <div v-else>
            <label>Order Code (If left blank one will be generated):</label><br>
            <v-text-field v-model="order.orderCode" name="orderCode" label="Order Code"></v-text-field>
          </div>

          <!-- Item Table -->
          <v-card>
            <v-card-title><h4>Items</h4></v-card-title>
            <v-divider></v-divider>
            <v-data-table :headers="itemHeaders" :items="indexedItems" item-key="id" :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" :loading="itemsLoading" :expand="true"  ref="sortableTable">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr class="sortableRow sortHandle">
                  <td>{{ getItemName(props.item) }}
                  </td>
                  <td>{{ props.item.type }}</td>
                  <td class="text-xs-right">{{ props.item.width }}</td>
                  <td class="text-xs-right">{{ props.item.drop }}</td>
                  <!-- <td class="text-xs-right" v-if="props.item.total">
                    ${{ ( props.item.total ).toFixed(2) }}
                    </td>
                  <td v-else>$0</td> -->
                  <td>${{ getItemTotal(props.item) }}</td>
                  <td>
                    <v-icon @click="editItem(props.item.id)">edit</v-icon>
                    <v-icon @click="confirmDeleteItem(props.item)">delete</v-icon>
                    <v-icon @click="showHideDetails(props.item.id)">keyboard_arrow_down</v-icon>
                    <div v-show="showDetails[props.item.id] === true" style="position: absolute; z-index: 1; width:100%; left:0;">
                      <v-card flat style="background:#eee;">
                        <v-card-text v-if="props.item.type != 'Misc' && props.item.type != 'Motor Accessories' && props.item.type != 'Custom Curtain'">
                          <p v-if="props.item.fabric"><b>Fabric:</b> {{ props.item.fabric.name }}</p>
                          <p v-if="props.item.color"><b>Colour:</b> {{ props.item.color.name }}</p>
                          <p v-for="(variation, key) in props.item.variations" :key="key">
                            <b>{{ key.charAt(0).toUpperCase() + key.slice(1).split(/(?=[A-Z])/).join(" ") }}: </b>
                            <span v-if="key === 'secondFabric' || key === 'secondColor'">{{ variation ? variation.name : ''  }} </span>
                            <span v-else>{{ variation  }} </span>
                          </p>
                          <p v-if="props.item.motorPrice > 0"><b>Motor:</b> {{ props.item.motor }}</p>
                          <p v-if="props.item.motorPrice > 0"><b>Motor Price:</b> {{ props.item.motorPrice }}</p>
                          <p v-if="props.item.notes"><b>Line Item Notes: </b>{{props.item.notes}}</p>
                        </v-card-text>
                        <v-card-text v-if="props.item.type == 'Custom Curtain'">
                          <p v-for="(variation, key) in props.item.variations" :key="key">
                            <b>{{ key.charAt(0).toUpperCase() + key.slice(1).split(/(?=[A-Z])/).join(" ") }}: </b>
                            <span v-if="(key === 'brand' || key === 'range') && variation">{{ variation.name  }} </span>
                            <span v-else>{{ variation  }} </span>
                          </p>
                        </v-card-text>
                        <v-card-text v-if="props.item.type == 'Motor Accessories'">
                          <div><b>Quantity</b>
                            <div style="border: 1px solid; width:235px;">
                              <v-btn small color="primary" class="qty_btn" @click="quantityMinus(props.item)">-</v-btn>
                              {{props.item.quantity}}
                              <v-btn small color="primary" class="qty_btn" @click="quantityPlus(props.item)">+</v-btn>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </td>
                </tr>
              </template>
              <!-- <template slot="expand" slot-scope="props">
                <v-card flat>
                  <v-card-text v-if="props.item.type != 'Misc' && props.item.type != 'Custom Curtain'">
                    <p v-if="props.item.fabric"><b>Fabric:</b> {{ props.item.fabric.name }}</p>
                    <p v-if="props.item.color"><b>Colour:</b> {{ props.item.color.name }}</p>
                    <p v-for="(variation, key) in props.item.variations" :key="key">
                      <b>{{ key.charAt(0).toUpperCase() + key.slice(1).split(/(?=[A-Z])/).join(" ") }}: </b>
                      <span v-if="key === 'secondFabric' || key === 'secondColor'">{{ variation.name  }} </span>
                      <span v-else>{{ variation  }} </span>
                    </p>
                    <p v-if="props.item.motorPrice > 0"><b>Motor:</b> {{ props.item.motor }}</p>
                    <p v-if="props.item.motorPrice > 0"><b>Motor Price:</b> {{ props.item.motorPrice }}</p>
                    <p v-if="props.item.notes"><b>Line Item Notes: </b>{{props.item.notes}}</p>
                  </v-card-text>
                  <v-card-text v-if="props.item.type == 'Custom Curtain'">
                    <p v-for="(variation, key) in props.item.variations" :key="key">
                      <b>{{ key.charAt(0).toUpperCase() + key.slice(1).split(/(?=[A-Z])/).join(" ") }}: </b>
                      <span v-if="(key === 'brand' || key === 'range') && variation">{{ variation.name  }} </span>
                      <span v-else>{{ variation  }} </span>
                    </p>
                  </v-card-text>
                </v-card>
              </template>
              <template slot="no-data">
                {{ itemsLoadingText }}
              </template> -->
            </v-data-table>
          </v-card>

          <br>

          <!-- Pricing -->
          <v-card>
            <v-container fluid grid-list-xl>
              <v-text-field v-model="order.shipping" name="shipping" label="Shipping"></v-text-field>
              <v-text-field v-if="!incInstall" v-model="order.install" name="install" label="Install"></v-text-field>
              <v-text-field v-model="order.measure" name="measure" label="Measure"></v-text-field>
            </v-container>
          </v-card>

          <br>

          <!-- Pricing Display -->
          <v-card>
            <v-card-title><h4>Pricing</h4></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-text-field v-model="promocode" label="Apply Promocode">
                <template slot="append">
                  <v-btn small color="primary" @click="applyPromocode()">Apply</v-btn>
                </template>
              </v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>Sub Total:</v-list-tile-content>
                <v-list-tile-content class="align-end">${{ order.subTotal }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Shipping:</v-list-tile-content>
                <v-list-tile-content class="align-end">${{ order.shipping }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="!incInstall">
                <v-list-tile-content>Install:</v-list-tile-content>
                <v-list-tile-content class="align-end">${{ order.install }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Measure:</v-list-tile-content>
                <v-list-tile-content class="align-end">${{ order.measure }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Discount:</v-list-tile-content>
                <v-list-tile-content class="align-end">-${{ order.discount }}</v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-content><h4>Total:</h4></v-list-tile-content>
                <v-list-tile-content class="align-end"><h4>${{ order.subTotal + ((order.shipping == '' || order.shipping == null) ? 0 : parseInt(order.shipping)) + ((order.install == '' || order.install == null) ? 0 :parseInt(order.install)) + ((order.measure == '' || order.measure == null) ? 0 : parseInt(order.measure)) - order.discount }}</h4></v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>

          <br>

          <!-- Customer -->
          <v-card>
            <v-card-title>
              <h4>Customer</h4>
            </v-card-title>
            <hr>
            <v-card-text>
              <div>
                <v-autocomplete v-if="customers" v-model="existingCustomer" :items="customers" item-value="_id" label="Select Existing Customers" :filter="filterCustomer">
                  <template slot="selection" slot-scope="data">
                    {{ data.item.firstName }} {{ data.item.lastName }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="`${data.item.firstName} ${data.item.lastName}`"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </div>

              <div>
                <h4 v-if="!existingCustomer">Create New Customer:</h4>
                <h4 v-else>Existing Customer</h4>
                <v-divider></v-divider>
                <div v-if="$v.customer.firstName.$error" class="red--text">Please enter first name</div>
                <v-text-field label="First Name" v-model="customer.firstName" :v="$v.customer.firstName"></v-text-field>

                <div v-if="$v.customer.lastName.$error" class="red--text">Please enter last name</div>
                <v-text-field label="Last Name" v-model="customer.lastName"></v-text-field>

                <div v-if="!$v.customer.email.required && $v.customer.email.$error" class="red--text">Please enter email</div>
                <div v-if="!$v.customer.email.email" class="red--text">Please enter valid email</div>
                <v-text-field label="Email" v-model="customer.email"></v-text-field>

                <div v-if="$v.customer.phone.$error" class="red--text">Please enter phone</div>
                <v-text-field label="Phone" v-model="customer.phone"></v-text-field>
              </div>
              <div>
                <v-card>
                  <v-card-title>
                    <h4>Address:</h4>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div v-if="$v.address.address.$error" class="red--text">Please enter street address</div>
                    <v-text-field label="Street Address" v-model="address.address"></v-text-field>

                    <div v-if="$v.address.city.$error" class="red--text">Please enter city</div>
                    <v-text-field label="Suburb / City" v-model="address.city"></v-text-field>

                    <div v-if="$v.address.state.$error" class="red--text">Please select state</div>
                    <v-select :items="states" item-text="name" item-value="code" v-model="address.state" label="State"></v-select>

                    <div v-if="$v.address.postcode.$error" class="red--text">Please enter postcode</div>
                    <v-text-field label="Postcode" v-model="address.postcode"></v-text-field>
                  </v-card-text>
                </v-card>
                <v-checkbox
                  v-model="differentShippingAddress"
                  label="Different Shipping Address?"
                ></v-checkbox>
                <v-card v-if="differentShippingAddress">
                  <!-- <v-card-text v-if='existingCustomer'>
                    <v-select :items="shippingAddresses" clearable item-text="name" item-value="id" v-model="currentShippingAddress" label="Select Shipping Address"></v-select>
                  </v-card-text> -->
                  <v-card-title>
                    <h4>Shiping Address:</h4>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <!-- <div v-if="$v.shippingAddress.addressName.$error" class="red--text">Please enter address name</div>
                    <v-text-field label="Address Name" v-model="shippingAddress.addressName"></v-text-field> -->

                    <div v-if="$v.shippingAddress.address.$error" class="red--text">Please enter street address</div>
                    <v-text-field label="Street Address" v-model="shippingAddress.address"></v-text-field>

                    <div v-if="$v.shippingAddress.city.$error" class="red--text">Please enter city</div>
                    <v-text-field label="Suburb / City" v-model="shippingAddress.city"></v-text-field>

                    <div v-if="$v.shippingAddress.state.$error" class="red--text">Please select state</div>
                    <v-select :items="states" item-text="name" item-value="code" v-model="shippingAddress.state" label="State"></v-select>

                    <div v-if="$v.shippingAddress.postcode.$error" class="red--text">Please enter postcode</div>
                    <v-text-field label="Postcode" v-model="shippingAddress.postcode"></v-text-field>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-card>
          <br>
          <v-card v-if='1 === 1'>
            <form @submit.prevent='sendFile' enctype="multipart/form-data" style='display:none'>
              <div class="field">
                <label for="checkMeasure" class="label"> Upload File </label>
                <input
                  type="file"
                  @change="selectFile"
                  ref="checkMeasure"
                  accept=".jpg, .jpeg, .png, .pdf"
                  multiple
                />
              </div>
            </form>
            <v-btn @click="$refs.checkMeasure.click()">Browse check Measure</v-btn>
            <v-btn @click="sendFile()">Upload</v-btn>
            <!-- <span v-if='checkMeasure'>{{checkMeasure}}</span> -->
            <!-- {{order.checkMeasureImg}} -->
            <!-- <v-btn v-if="order.checkMeasureImg && checkMeasureImgExist" @click="downloadCheckMeasure()">Download check Measure</v-btn> -->
          </v-card>
          <v-card>
            <div v-for="(file, index) in checkMeasures" :key="'aa' + index" class="level">
              <v-container fluid grid-list-xl style="background:#ddd">
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <div class="level-item">{{file.name}} &nbsp; <span v-if="order.checkMeasureImg.includes(file.name)" style="color: red">(wil be overwrite)</span></div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-icon @click.prevent="checkMeasures.splice(index, 1)">delete</v-icon>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <div v-for="(file, index) in order.checkMeasureImg" :key="'bb' + index" class="level">
              <v-container fluid grid-list-xl>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <a @click="downloadCheckMeasure(file)" class="level-item">{{file}}</a>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-icon @click.prevent="order.checkMeasureImg.splice(index, 1)">delete</v-icon>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-card>
          <br>

          <v-card>
            <v-container fluid grid-list-xl>
              <v-textarea name="remarks" label="Remarks" v-model="order.remarks"></v-textarea>
            </v-container>
          </v-card>

          <br>
          <div v-if="customerSavingError" class="red--text">{{ customerSavingError }}</div>
          <v-btn v-if="!this.$route.params.id" color="primary" large @click="addOrder()">Add</v-btn>
          <v-btn v-else color="primary" large  @click="updateOrder()">Update</v-btn>
        </v-form>
      </v-flex>

      <!-- Products -->
      <v-flex xs12 sm6>
        <label>Select a product type to add:</label><br>
        <v-select :items="[{ text: 'Roller Blind' },
        { text: 'Double Roller Blind'},
        { text: 'Roman Blind' },
        { text: 'Venetian Blind' },
        { text: 'Honeycomb Blind' },
        { text: 'Shutter' },
        { text: 'Linked Roller Blind' },
        { text: 'Linked Double Roller Blind' },
        { text: 'Shutter' },
        { text: 'Panel Glide Blind' },
        { text: 'Vertical Blind' },
        { text: 'Curtain' },
        { text: 'Custom Curtain' },
        { text: 'Misc' }]" v-model="itemType" @change="checkEdit" label="Add Item to Quote"></v-select>
        <v-card v-if="itemType">
          <v-card-title v-if="!edit"><h4>Add {{ itemType }}</h4></v-card-title>
          <v-card-title v-else><h4>Edit {{ itemType }}</h4></v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <rollerBlind v-if="itemType == 'Roller Blind'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <linkedRollerBlind v-if="itemType == 'Linked Roller Blind'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <shutter v-if="itemType == 'Shutter'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <curtain v-if="itemType == 'Curtain'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <doubleRollerBlind v-if="itemType == 'Double Roller Blind'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <linkedDoubleRollerBlind v-if="itemType == 'Linked Double Roller Blind'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <misc v-if="itemType == 'Misc'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <panelGlideBlind v-if="itemType == 'Panel Glide Blind'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <romanBlind v-if="itemType == 'Roman Blind'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <venetianBlind v-if="itemType == 'Venetian Blind'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <verticalBlind v-if="itemType == 'Vertical Blind'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <honeycombBlind v-if="itemType == 'Honeycomb Blind'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
            <CustomCurtain v-if="itemType == 'Custom Curtain'" :edittingItem="edittingItem" :editChange="editChange" v-on:create-item="addItem($event)"/>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="edit" color="primary " @click="cancelItem()">Cancel</v-btn>
            <v-btn v-else color="primary " @click="itemType = null">Done</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

     <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>

     <!-- Confirmation Popup -->
    <v-dialog v-model="customerDialog" max-width="400px">
      <v-card v-if="selectedItem">
        <v-card-title>Please confirm</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Are you sure you want to delete <b>{{ selectedItem.name }}</b>?</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" flat @click="customerDialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="deleteItem(selectedItem.id)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import OrderService from '@/services/OrderService'
import CustomerService from '@/services/CustomerService'
import AddressService from '@/services/AddressService'
import ItemService from '@/services/ItemService'
import PromocodeService from '@/services/PromocodeService'
import FabricService from '@/services/FabricService'
import ColorService from '@/services/ColorService'
import CurtainService from '@/services/CurtainService'
import PostcodeService from '@/services/PostcodeService'

import rollerBlind from '@/components/products/RollerBlind'
import linkedRollerBlind from '@/components/products/LinkedRollerBlind'
import shutter from '@/components/products/Shutter'
import curtain from '@/components/products/Curtain'
import doubleRollerBlind from '@/components/products/DoubleRollerBlind'
import linkedDoubleRollerBlind from '@/components/products/LinkedDoubleRollerBlind'
import misc from '@/components/products/Misc'
import panelGlideBlind from '@/components/products/PanelGlideBlind'
import romanBlind from '@/components/products/RomanBlind'
import venetianBlind from '@/components/products/VenetianBlind'
import verticalBlind from '@/components/products/VerticalBlind'
import honeycombBlind from '@/components/products/HoneycombBlind'
import CustomCurtain from '@/components/admin/CustomCurtains'
import { required, email } from 'vuelidate/lib/validators'
import Sortable from 'sortablejs'
import _ from 'lodash'

// const gConfig = require('../../../gConfig.json')
var gConfig
if (process.env.NODE_ENV === 'production') {
  gConfig = require('../../../gConfigProduction.json')
} else if (process.env.NODE_ENV === 'staging') {
  gConfig = require('../../../gConfigStaging.json')
} else {
  gConfig = require('../../../gConfig.json')
}

export default {
  name: 'NewQuote',
  components: {
    rollerBlind,
    linkedRollerBlind,
    shutter,
    curtain,
    doubleRollerBlind,
    linkedDoubleRollerBlind,
    misc,
    panelGlideBlind,
    romanBlind,
    venetianBlind,
    verticalBlind,
    honeycombBlind,
    CustomCurtain
  },
  computed: {
    indexedItems () {
      return this.items.map((item, index) => ({
        id: index,
        ...item
      }))
    }
  },
  data () {
    return {
      checkMeasures: [],
      checkMeasureImgExist: false,
      rowsPerPageItems: [],
      pagination: {
        rowsPerPage: 100
      },
      showDetails: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false,
        13: false,
        14: false,
        15: false,
        16: false,
        17: false,
        18: false,
        19: false,
        20: false,
        21: false,
        22: false,
        23: false,
        24: false,
        25: false
      },
      isModalVisible: false,
      edit: false,
      editChange: false,
      customerSavingError: null,
      order: {
        orderCode: '',
        shipping: null,
        insurance: null,
        discount: null,
        install: null,
        measure: null,
        subTotal: null,
        customerID: null,
        promocodeID: null,
        status: null,
        date: null,
        IP: null,
        browser: null,
        remarks: '',
        dueDate: null,
        checkMeasureImg: []
      },
      items: [],
      tempItems: [],
      itemHeaders: [
        { text: 'Room Name', value: 'roomName' },
        { text: 'Type', value: 'type' },
        { text: 'Width', value: 'width' },
        { text: 'Drop', value: 'drop' },
        { text: 'Price', value: 'price' },
        { text: 'Actions', value: 'actions' }
      ],
      selectedItem: null,
      customerDialog: false,
      itemType: null,
      customers: null,
      existingCustomer: null,
      edittingItem: null,
      editIndex: 0,
      customer: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        address: null
      },
      address: {
        address: null,
        city: null,
        state: null,
        postcode: null
      },
      shippingAddress: {
        // addressName: null,
        address: null,
        city: null,
        state: null,
        postcode: null
      },
      states: [
        { code: 'VIC', name: 'Victoria' },
        { code: 'NSW', name: 'New South Wales' },
        { code: 'QLD', name: 'Queensland' },
        { code: 'ACT', name: 'Australian Capital Territory' },
        { code: 'SA', name: 'South Australia' },
        { code: 'WA', name: 'Western Australia' },
        { code: 'NT', name: 'Northern Territory' },
        { code: 'TAS', name: 'Tasmania' }
      ],
      itemsLoading: true,
      itemsLoadingText: 'Loading...',
      snackbar: false,
      popupText: null,
      promocode: null,
      incInstall: gConfig.install,
      differentShippingAddress: false,
      shippingAddresses: [],
      currentShippingAddress: ''
    }
  },
  validations: {
    customer: {
      firstName: { required },
      lastName: { required },
      email: { required, email },
      phone: { required }
    },
    address: {
      address: { required },
      city: { required },
      state: { required },
      postcode: { required }
    },
    shippingAddress: {
      address: { required },
      city: { required },
      state: { required },
      postcode: { required }
      // addressName: { required }
    }
  },
  mounted () {
    this.getCustomers()
    this.getQuote()
    // make table draggable and sortable
    /* eslint-disable no-new */
    new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        onEnd: this.dragReorder
      }
    )
  },
  watch: {
    existingCustomer: function (customerId) {
      this.setCustomerInfo(customerId)
    },
    currentShippingAddress: function (addressId) {
      this.setCustomerShippingAddress(addressId)
    },
    'address.postcode': {
      async handler (address) {
        await this.checkOrderItemsForShipping()
      },
      deep: true
    },
    'order.install': {
      async handler (install) {
        await this.checkOrderItemsForShipping()
      },
      deep: true
    }
  },
  methods: {
    async checkMeasureImgExistOrNot (file) {
      let response = await OrderService.checkfileexist(file)
      return response.data.status
    },
    async sendFile () {
      // for multiple files upload
      const formData = new FormData()
      _.forEach(this.checkMeasures, file => {
        if (this.validate(file) === '') {
          formData.append('files', file)
        }
      })
      let response = await OrderService.uploadCMs(formData)
      _.forEach(response.data.files, file => {
        if (!this.order.checkMeasureImg.includes(file.filename)) {
          this.order.checkMeasureImg.push(file.filename)
        }
      })
      this.checkMeasures = []
      // return response
    },
    async downloadCheckMeasure (file) {
      let vm = this
      // this.checkMeasureImgExistOrNot(file).then(function (val) {
      //   // if (this.checkMeasureImgExistOrNot(file)) {
      //   if (val) {
      //     vm.checkMeasureImgExist = true
      //     window.open(gConfig.apiURL + '/downloadCheckMeasure?file=' + file)
      //     vm.popupText = 'image generated'
      //     vm.snackbar = true
      //   } else {
      //     vm.popupText = 'image not exist'
      //     vm.snackbar = true
      //   }
      // })
      vm.checkMeasureImgExist = true
      window.open(gConfig.mediaURL + '/API/checkMeasures/' + file)
      vm.popupText = 'image generated'
      vm.snackbar = true
    },
    selectFile () {
      // for multiple files
      const files = this.$refs.checkMeasure.files
      this.checkMeasures = [ ...this.checkMeasures, ...files ]
    },
    validate (file) {
      // const MAX_SIZE = 200000
      // const allowedTypes = ['image/jpeg', 'image/jpg']
      // if (file.size > MAX_SIZE ) {
      //   return `Max size: ${MAX_SIZE/1000}Kb`
      // }
      // if (!allowedTypes.includes(file.type)) {
      //   return 'File type not allowed'
      // }
      return ''
    },
    sortByOrdering (a, b) {
      // Use toUpperCase() to ignore character casing
      const orderingA = a.ordering
      const orderingB = b.ordering
      let comparison = 0
      if (orderingA > orderingB) {
        comparison = 1
      } else if (orderingA < orderingB) {
        comparison = -1
      }
      return comparison
    },
    async dragReorder ({oldIndex, newIndex}) {
      let tempItems = JSON.parse(JSON.stringify(this.tempItems))
      console.log(tempItems)
      tempItems.splice(newIndex, 0, tempItems.splice(oldIndex, 1)[0])
      let count = 0
      tempItems.forEach((item, index) => {
        if (item) {
          tempItems[index].ordering = count++
          console.log(tempItems[index].name)
          console.log(tempItems[index].ordering)
        }
      })
      console.log(tempItems)
      this.tempItems = tempItems
    },
    checkEdit () {
      if (this.edit) {
        this.editChange = true
      } else {
        this.editChange = false
      }
    },
    async addOrder () {
      let vm = this
      let orderAddress

      // if (this.checkMeasures.length > 0) {
      //   let sendfiles = await this.sendFile()
      //   _.forEach(sendfiles, file => {
      //     this.order.checkMeasureImg.push(file.filename)
      //   })
      //   // this.order.checkMeasureImg = sendfile.file.filename
      // }
      console.log(this.order)
      if (!this.validateFields()) { return }

      vm.popupText = 'Adding Order...'
      vm.snackbar = true

      if (this.order.orderCode.length > 0) {
        var orderCode = this.order.orderCode
      }

      // If new customer, create address and customer
      var customerID
      if (!this.existingCustomer) {
        // Save the Customer and address first
        const addressResponse = await AddressService.createAddress(this.address)
        this.customer.address = addressResponse.data.address._id
        orderAddress = addressResponse.data.address._id
        // Save the shipping address first
        if (this.differentShippingAddress) {
          const shippingAddressResponse = await AddressService.createAddress(this.shippingAddress)
          this.customer.shippingAddress = [shippingAddressResponse.data.address._id]
          orderAddress = shippingAddressResponse.data.address._id
        }

        // Take the ID of the address and save a reference of it to the customer, then save the customer
        const customerResponse = await CustomerService.addCustomer(this.customer)
        if (customerResponse.data.success) {
          this.customerSavingError = ''
          customerID = customerResponse.data.customer._id
        } else {
          this.customerSavingError = customerResponse.data.message
          return
        }
      } else {
        // We already have a customer reference with an address
        customerID = this.existingCustomer
        // for address
        await CustomerService.updateAddress({ address: this.address })
        orderAddress = this.address._id
        // for shipping Address
        if (this.currentShippingAddress) {
          if (this.differentShippingAddress) {
            await CustomerService.updateAddress({ address: this.shippingAddress })
            orderAddress = this.currentShippingAddress
          }
        } else {
          if (this.differentShippingAddress) {
            const shippingAddressResponse = await AddressService.createAddress(this.shippingAddress)
            let AllShippingAddress = this.shippingAddresses.map(a => a.id) // get only id from object
            AllShippingAddress.push(shippingAddressResponse.data.address._id)
            this.customer.shippingAddress = AllShippingAddress
            orderAddress = shippingAddressResponse.data.address._id
            await CustomerService.updateCustomer({ customer: this.customer })
          }
        }
      }

      // Date to today
      this.order.date = new Date()

      // Now that the customer and address are saved we can create the order
      this.order.customerID = customerID
      var newOrder = {
        orderCode: orderCode,
        shipping: this.order.shipping,
        insurance: this.order.insurance,
        discount: this.order.discount,
        install: this.order.install,
        measure: this.order.measure,
        subTotal: this.order.subTotal,
        customerID: this.order.customerID,
        promocodeID: this.order.promocodeID,
        status: 'Quote',
        date: this.order.date,
        IP: this.order.IP,
        browser: this.order.browser,
        remarks: this.order.remarks,
        dueDate: this.order.dueDate,
        freeSampleOrder: false,
        differentShippingAddress: false
      }
      if (this.differentShippingAddress) {
        newOrder.address = orderAddress
        newOrder.differentShippingAddress = true
      }

      const orderResponse = await OrderService.addOrder(newOrder)
      var orderID = orderResponse.data.order._id

      // Change forEach loop to for loop because forEach loop will not wait until Item is saved
      // If we want to save items/products in sequence then we can not use forEach because forEach will fire all the call together and does not wait until previous call finish
      var insertCount = 0
      for (let item of this.items) {
        item.orderID = orderID

        if (item.type === 'Linked Double Roller Blind') {
          if (item.variations.secondFabric._id) {
            item.variations.secondFabric = item.variations.secondFabric._id
          }
          if (item.variations.secondColor._id) {
            item.variations.secondColor = item.variations.secondColor._id
          }
        }

        if (item.type !== 'Custom Curtain') {
          await ItemService.addItem(item)
        } else {
          await ItemService.addCustomCurtain(item)
        }
        insertCount++
        if (insertCount === vm.items.length) {
          vm.$router.push({ name: 'Quotes', params: { created: orderResponse.data.order.orderCode } })
        }
      }
    },

    async updateOrder () {
      let vm = this

      if (!this.validateFields()) { return }

      // if (this.checkMeasures.length > 0) {
      //   let sendfiles = await this.sendFile()
      //   console.log(sendfiles)
      //   _.forEach(sendfiles.data.files, file => {
      //     this.order.checkMeasureImg.push(file.filename)
      //   })
      // }
      console.log(this.order)

      if (this.customer.address) {
        await CustomerService.updateAddress({ address: this.address })
      } else {
        const addressResponse = await AddressService.createAddress(this.address)
        this.customer.address = addressResponse.data.address._id
      }

      // for shipping Address
      this.order.differentShippingAddress = false
      if (this.differentShippingAddress) {
        if (this.currentShippingAddress) {
          await CustomerService.updateAddress({ address: this.shippingAddress })
          this.order.address = this.currentShippingAddress
        } else {
          const shippingAddressResponse = await AddressService.createAddress(this.shippingAddress)
          let AllShippingAddress = this.shippingAddresses.map(a => a.id) // get only id from object
          AllShippingAddress.push(shippingAddressResponse.data.address._id)
          this.customer.shippingAddress = AllShippingAddress
          this.order.address = shippingAddressResponse.data.address._id
        }
        this.order.differentShippingAddress = true
      }

      await CustomerService.updateCustomer({ customer: this.customer })

      // Instead of creating new documents we need to update the existing.
      // console.log(this.order)
      await OrderService.updateOrder(this.order)

      // Change forEach loop to for loop because forEach loop will not wait for until Item is saved / update
      var updateCount = 0
      // for new ordering items
      this.items = this.tempItems
      for (let item of this.items) {
        if (item.type === 'Linked Double Roller Blind') {
          if (item.variations.secondFabric._id) {
            item.variations.secondFabric = item.variations.secondFabric._id
          }
          if (item.variations.secondColor._id) {
            item.variations.secondColor = item.variations.secondColor._id
          }
        }
        if (item.type !== 'Custom Curtain') {
          const response = await ItemService.updateItem(item)
          if (!response.data.success) {
            // We're assuming the error was because the item doesn't exist yet, probably not great...
            item.orderID = vm.$route.params.id
            await ItemService.addItem(item)
          }
        } else {
          const response = await ItemService.updateCustomCurtain(item)
          if (!response.data.success) {
            // We're assuming the error was because the item doesn't exist yet, probably not great...
            item.orderID = vm.$route.params.id
            await ItemService.addCustomCurtain(item)
          }
        }

        updateCount++
        if (updateCount === vm.items.length) {
          vm.$router.push({ name: 'Quotes' })
        }
      }
    },

    async getQuote () {
      if (this.$route.params.id) {
        const response = await OrderService.getOrder({
          id: this.$route.params.id
        })
        this.order = response.data.order
        if (this.order.promocodeID) {
          this.promocode = this.order.promocodeID.name
        }
        this.customer = this.order.customerID

        this.existingCustomer = this.customer._id

        if (this.customer.address) {
          this.address = this.customer.address
        }
        // this.order.subTotal = 0
        const itemResponse = await OrderService.getItems(this.$route.params.id)
        this.items = itemResponse.data.items

        // for (let index = 0; index < this.items.length; index++) {
        //   let item = this.items[index]
        //   let total = item.total
        //   if (item.type === 'Motor Accessories' && item.quantity) {
        //     total = total * item.quantity
        //     // this.items[index].total = total * item.quantity
        //     // this.items[index].name = item.quantity + ' x ' + item.name
        //   }
        //   this.order.subTotal += total
        // }

        const customCurtainResponse = await ItemService.getCustomCurtains(this.$route.params.id)
        // Add type as Custom Curtain because in edit list system was throwing error for name.
        var CustomCurtainsR = customCurtainResponse.data.customCurtains.map((customCur) => ({
          type: 'Custom Curtain',
          ...customCur
        }))
        if (CustomCurtainsR.length !== 0) {
          customCurtainResponse.data.customCurtains = CustomCurtainsR
          if (this.items.length !== 0) {
            for (let customItem of CustomCurtainsR) {
              this.items.push(customItem)
            }
          } else {
            this.items = customCurtainResponse.data.customCurtains
          }
          for (let customItem of CustomCurtainsR) {
            this.order.subTotal += customItem.total
          }
        }
        this.tempItems = this.items
        this.items.sort(this.sortByOrdering)
        // console.log(this.items)

        if (this.items.length === 0) {
          this.itemsLoadingText = 'No items yet.'
        }
        this.differentShippingAddress = this.order.differentShippingAddress
        let shippingAddresses = await AddressService.getShippingAddresses(this.customer.shippingAddress)
        if (this.order.address) {
          for (let index = 0; index < shippingAddresses.data.addresses.length; index++) {
            const element = shippingAddresses.data.addresses[index]
            if (element._id === this.order.address._id) {
              this.currentShippingAddress = element._id
            }
          }
        }
        this.itemsLoading = false
      } else {
        this.itemsLoading = false
        this.itemsLoadingText = 'No items yet.'
      }
      await this.checkOrderItemsForShipping()
    },

    async getCustomers () {
      const response = await CustomerService.fetchCustomers()
      this.customers = response.data.customers
    },

    setCustomerShippingAddress (addressId) {
      this.resetCustomerShippingAddress()
      if (this.currentShippingAddress) {
        this.fillShippingAddress()
      }
    },

    async fillShippingAddress () {
      const response = await AddressService.getAddress(this.currentShippingAddress)
      let address = response.data.address
      this.shippingAddress = address
    },
    async setCustomerInfo (customerId) {
      this.resetCustomerAddress()
      this.resetCustomerShippingAddress()
      this.resetCustomerInfo()
      if (customerId) {
        const response = await CustomerService.getCustomer(customerId)
        this.customer = response.data.customer
        if (response.data.customer.address) {
          this.address = response.data.customer.address
        }
        if (response.data.customer.shippingAddress) {
          let shippingAddresses = await AddressService.getShippingAddresses(response.data.customer.shippingAddress)
          this.shippingAddresses = []
          for (let index = 0; index < shippingAddresses.data.addresses.length; index++) {
            const address = shippingAddresses.data.addresses[index]
            let temp = { id: address._id, name: address.addressName ? address.addressName : 'Shipping Address' }
            this.shippingAddresses.push(temp)
          }
        }
      }
    },

    async addItem (item) {
      item.total = parseFloat(item.total)

      if (item.type !== 'Misc' && item.type !== 'Custom Curtain') {
        if (!item.fabric._id) {
          const FabricInfo = await FabricService.getFabric(item.fabric)
          item.fabric = FabricInfo.data.fabric
        }

        if (!item.color._id) {
          const ColorInfo = await ColorService.getColor(item.color)
          item.color = ColorInfo.data.color
        }
      }
      if (item.type === 'Double Roller Blind' || item.type === 'Linked Double Roller Blind') {
        if (!item.variations.secondFabric._id) {
          const SecondFabricInfo = await FabricService.getFabric(item.variations.secondFabric)
          item.variations.secondFabric = SecondFabricInfo.data.fabric
        }

        if (!item.variations.secondColor._id) {
          const SecondColorInfo = await ColorService.getColor(item.variations.secondColor)
          item.variations.secondColor = SecondColorInfo.data.color
        }
      }

      if (item.type === 'Custom Curtain') {
        if (item.variations.brand && !item.variations.brand._id) {
          const Brand = await CurtainService.getBrand(item.variations.brand)
          item.variations.brand = Brand.data.brand
        }

        if (item.variations.range && !item.variations.range._id) {
          const Rang = await CurtainService.getRange(item.variations.range)
          item.variations.range = Rang.data.range
        }
      }

      if (this.edit) {
        var oldItem = this.items[this.editIndex]

        this.order.subTotal -= parseFloat(oldItem.total)

        this.$set(this.items, this.editIndex, item)

        this.itemType = null
        this.edittingItem = null
      } else {
        // Change Object.assign to JSON.stringify because when we have multiple objects Object.assign will not work
        item.ordering = this.items.length + 1
        var itemStringify = JSON.stringify(item)
        this.items.push(JSON.parse(itemStringify))
      }

      this.order.subTotal += parseFloat(item.total)

      if (this.edit) {
        this.popupText = `Item '${item.name}' updated.`
        this.edit = false
      } else {
        this.popupText = `Item '${item.name}' created.`
      }

      await this.checkOrderItemsForShipping()

      if (this.promocode) {
        this.applyPromocode2()
      }

      this.snackbar = true
      this.editChange = false
    },
    async checkOrderItemsForShipping () {
      if (this.order.install > 0) {
        this.order.shipping = 0
      } else {
        let shutter = 0
        // let other = 0
        let shipping = 0
        let shutterPrice = 0
        for (let index = 0; index < this.items.length; index++) {
          const item = this.items[index]
          if (item.type === 'Shutter') {
            shutter = 1
            shutterPrice += item.total
          } else {
            // other = 1
          }
        }
        // if (other === 1) {
        //   shipping = 30
        // }
        shipping = 30 // it will 30 addition for shipping even only shutter is in order
        if (shutter === 1) {
          let postcode = this.address.postcode
          let shutterShippingPrice = await this.getShutterShippingPrice(shutterPrice, postcode)
          shipping += shutterShippingPrice
        }
        this.order.shipping = shipping
      }
    },
    editItem (index) {
      this.edit = true
      this.edittingItem = JSON.parse(JSON.stringify(this.items[index]))

      this.editIndex = index

      this.itemType = this.edittingItem.type
      this.editChange = false
    },

    cancelItem () {
      this.edit = false
      this.itemType = null
      this.edittingItem = null
    },

    confirmDeleteItem (item) {
      this.selectedItem = item
      this.customerDialog = true
    },

    async deleteItem (index) {
      this.customerDialog = false
      const item = this.items[index]
      this.order.subTotal -= parseInt(item.total)
      this.items.splice(index, 1)
      if (item.type !== 'Custom Curtain') {
        await ItemService.deleteItem(item._id)
      } else {
        await ItemService.deleteCustomCurtain(item._id)
      }

      if (this.promocode) {
        this.applyPromocode2()
      }
      this.popupText = `Item '${item.name}' deleted.`
      this.snackbar = true
    },

    async applyPromocode () {
      if (!this.order._id) {
        this.applyPromocode2()
        return
      }
      const response = await PromocodeService.applyPromocode({
        promocode: this.promocode,
        orderID: this.order._id
      })

      if (response.data.success) {
        this.popupText = `Promocode ${response.data.message} applied.`
        this.snackbar = true

        this.order.discount = response.data.amount
        this.order.promocodeID = response.data.promocode._id
      } else {
        this.popupText = `Promocode is not Valid.`
        this.snackbar = true
      }
    },

    // if items are not already in order yet
    async applyPromocode2 () {
      const response = await PromocodeService.applyPromocode2({
        promocode: this.promocode,
        items: this.items
      })

      if (response.data.success) {
        this.popupText = `Promocode ${response.data.message} applied.`
        this.snackbar = true

        this.order.discount = response.data.amount
        this.order.promocodeID = response.data.promocodeID
      } else {
        this.popupText = `Promocode is not Valid.`
        this.snackbar = true
      }
    },
    filterCustomer (item, queryText, itemText) {
      var name = ''
      if (item.firstName) {
        name += item.firstName.toLowerCase()
      }
      if (item.lastName) {
        name += ' ' + item.lastName.toLowerCase()
      }
      if (item.email) {
        name += ' ' + item.email.toLowerCase()
      }

      if (name) {
        const searchText = queryText.toLowerCase()
        return name.indexOf(searchText) > -1
      } else {
        return false
      }
    },
    validateFields () {
      this.$v.customer.$touch()
      this.$v.address.$touch()
      this.$v.shippingAddress.$touch()

      if (!this.existingCustomer) {
        if (this.$v.customer.$pending || this.$v.customer.$error) return false
      }

      if (this.$v.address.$pending || this.$v.address.$error) return false
      if (this.differentShippingAddress) {
        if (this.$v.shippingAddress.$pending || this.$v.shippingAddress.$error) return false
      }

      return true
    },

    resetCustomerAddress () {
      this.address.address = null
      this.address.city = null
      this.address.postcode = null
      this.address.state = null
    },
    resetCustomerShippingAddress () {
      // this.shippingAddress.addressName = null
      this.shippingAddress.address = null
      this.shippingAddress.city = null
      this.shippingAddress.postcode = null
      this.shippingAddress.state = null
    },

    resetCustomerInfo () {
      this.customer.firstName = null
      this.customer.lastName = null
      this.customer.email = null
      this.customer.phone = null
    },
    showHideDetails (id) {
      for (var prop in this.showDetails) {
        if (parseInt(prop) !== parseInt(id)) {
          this.showDetails[prop] = false
        }
      }
      this.showDetails[id] = !this.showDetails[id]
    },
    async getShutterShippingPrice (shutterPrice, postcode) {
      let postcodeResponse = await PostcodeService.getSinglePostcode(postcode)
      if (postcodeResponse.data.postcode.length > 0) {
        let getShutterPrice = postcodeResponse.data.postcode[0].shutterPrice
        shutterPrice = shutterPrice / 325
        return parseInt(Math.round(getShutterPrice * shutterPrice))
      } else {
        return 0
      }
    },
    getItemTotal (item) {
      return item.total.toFixed(2)
    },
    getItemName (item) {
      let name = item.name
      if (item.type === 'Motor Accessories' && item.quantity) {
        name = item.quantity + ' x ' + item.name
      }
      return name
    },
    async quantityPlus (item) {
      // this.order.subTotal -= this.items[item.id].total
      this.items[item.id].quantity++
      this.items[item.id].total = this.items[item.id].total + this.items[item.id].itemPrice
      this.order.subTotal += this.items[item.id].itemPrice
      let params = {id: this.items[item.id]._id, quantity: this.items[item.id].quantity}
      await ItemService.updateQuantity(params)
    },
    async quantityMinus (item) {
      if (this.items[item.id].quantity !== 1) {
        this.items[item.id].quantity--
        this.items[item.id].total = this.items[item.id].total - this.items[item.id].itemPrice
        this.order.subTotal -= this.items[item.id].itemPrice
        let params = {id: this.items[item.id]._id, quantity: this.items[item.id].quantity}
        await ItemService.updateQuantity(params)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/quotes/QuoteOld.vue